import { pipe } from "fp";
import React, { useState } from "react";

import { useDispatch } from "~/Action";
import * as Document from "~/Document";
import cabinet from "~/Document/Cabinet.svg";
import { Component as EmptyComponent } from "~/Empty";
import * as Layout from "~/Layout";

export const Component = () => {
  const currentDocument: Document.Active.Active = Document.Active.use();
  const [showDocument, setShowDocument] = useState(false);
  if (currentDocument && !showDocument) {
    setShowDocument(true);
  }

  return pipe(useDispatch(), (dispatch) => (
    <>
      <Layout.Page.Component all>
        <Layout.Section.Component>
          <Layout.Section.Header.Component
            Left={() => <Document.Search.Component />}
          >
            <Layout.Section.Header.Title>Documents</Layout.Section.Header.Title>
          </Layout.Section.Header.Component>

          {pipe(Document.Active.use(), (document) =>
            document ? (
              <Document.Detail.Component
                document={currentDocument}
                show={showDocument}
                onHide={() => {
                  setShowDocument(false);
                  dispatch(Document.Detail.Action.Cleared.create());
                }}
              />
            ) : null
          )}
          <Document.Table.Component />
        </Layout.Section.Component>
      </Layout.Page.Component>
    </>
  ));
};

export namespace Empty {
  export const Component = () => (
    <EmptyComponent
      title="You currently don't have any documents."
      subtitle="I'm going to need you to come in on Saturday."
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      svg={{ src: cabinet }}
    />
  );
}
